exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js??ref--6-oneOf-1-1!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../node_modules/postcss-loader/src/index.js??ref--6-oneOf-1-2!../../../style/security.css"), "");

// module
exports.push([module.id, "\n.layout-settings {\n  border: 1px solid #eeeeee;\n  border-radius: 10px;\n  margin-bottom: 20px;\n  background-color: #fff;\n}\n.layout-settings:hover {\n  -webkit-box-shadow: 0 0 15px #ccc;\n          box-shadow: 0 0 15px #ccc;\n}\n  ", ""]);

// exports
